import { useContext, useEffect, useRef, useState } from "react";
import Context from "./Context";
import styled from "styled-components";
import PlayerYT from "./PlayerYT";
import { formatarTempo } from "./utils";
import { Oval } from 'react-loader-spinner';

export default function Player() {
    const textoRef = useRef("");
    const inputRef = useRef(null);
    const playerRef = useRef(null)
    const {setMenu,id,setVideos,videos,notas,setNotas,tempo,setTempo}=useContext(Context)
    const [adding,setAdding]=useState(false)
    const [points,setPoints]=useState([])
    const [texto,setTexto]=useState('')
    const [num,setNum]=useState('')
    const [duration,setDuration]=useState(1)
    const [tamanhoBarra,setTamanhoBarra]=useState(640)
    const [loading,setLoading]=useState(true)
    function add(){
        setNum(playerRef.current.getCurrentTime())
        setAdding(true)
        playerRef.current.pauseVideo();
    }
    
    function save(txt=textoRef.current){
        const minutos=formatarTempo(num)
        setNotas([...notas,{
            id,
            texto:txt,
            num,
            minutos
        }])
        setAdding(false)
        setTexto('')
        setAdding(false)
        playerRef.current.playVideo();
    }
     useEffect(() => {
    if (adding) {
        inputRef.current?.focus();
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {save();}
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }
    }, [adding]);
    useEffect(() => {
        textoRef.current = texto;
    }, [texto]);
    useEffect(()=>{
        if(duration==1)return
        setLoading(false)
        const tamanhoTela=window.innerWidth
        if(tamanhoTela<850){
            setTamanhoBarra(tamanhoTela)
            playerRef.current.setSize(tamanhoTela, tamanhoTela*9/16)
        }else if(tamanhoTela<1050){
            const lv=window.innerWidth-350
            setTamanhoBarra(lv)
            playerRef.current.setSize(lv, lv*9/16)
        }
        let add=true
        for(let v of videos)if(v.id==id)add=false
        const minutos=formatarTempo(duration)
        if(add){
            const {title,author}=playerRef.current.getVideoData()
            const novoVideo={
            id,
            titulo:title,
            autor:author,
            minutos

        }
        setVideos([...videos,novoVideo])
        }
        setTexto('')
        setAdding(false)
    },[duration,id])
    useEffect(()=>{
        if(!playerRef.current)return
        if(!tempo || !playerRef.current.seekTo)return
        playerRef.current.seekTo(tempo, true)
        setTempo(false)
    },[tempo,duration])

    useEffect(()=>{
        if(duration==1)return
        setPoints(notas.filter(n=>n.id==id).sort((b,a)=>b.num-a.num))
    },[notas,id,duration])
    
    return(
        <Tudo>
            {loading?
                <Tudo style={{
                    position:'absolute',zIndex:10,top:0,
                    background:'#2A2A3F'
                }}>
                    <Holder>
                        <Oval height={100} width={100} color="#ffffff" wrapperStyle={{}} wrapperClass="" visible={true} ariaLabel="oval-loading"/>
                    </Holder>
                </Tudo>
            :<></>}
            <Esquerda>
            <PlayerYT playerRef={playerRef} videoId={id} setDuration={setDuration} />
            <Resto>
            <HolderPontos tamanho={tamanhoBarra}>
                <Barra></Barra>
                <Pontos>
                    {points?.map((p,i)=><PontoFlutuante
                        onClick={()=>setTempo(p.num)}
                        left={p.num*100/duration}
                        >{/*<BalaoFlutuante/>*/}</PontoFlutuante>)}
                </Pontos>
            </HolderPontos>
            
            </Resto>
            <HolderPontosPc>
                {points?.map((p,i)=>
                    <PontoCel onClick={()=>setTempo(p.num)}>
                        <p style={{margin:'10px'}}>{p.minutos}</p>
                        <p>{p.texto}</p>
                    </PontoCel>
                )}
            </HolderPontosPc>
            <HolderPontosCel>
                {points?.map((p,i)=>
                    <PontoCel onClick={()=>setTempo(p.num)}>
                        <p style={{margin:'10px'}}>{p.minutos}</p>
                        <p>{p.texto}</p>
                    </PontoCel>
                )}
            </HolderPontosCel>
            </Esquerda>
            <Direita>
                {adding?
                <NovoPonto>
                    <textarea 
                        ref={inputRef}
                        value={texto}
                        onChange={(e)=>setTexto(e.target.value)}
                        placeholder='Digite o texto...'
                    />
                    <button style={{background:texto?'#38dd35':'#8c8cad'}} onClick={()=>{if(texto)save()}}>Salvar</button>
                </NovoPonto>:
                <NovoPonto>
                    <button style={{background:'#38DD35'}} onClick={add}>Adicionar nota</button>
                </NovoPonto>
            }
            <HolderPontosPcDireita>
                {points?.map((p,i)=>
                    <PontoCel onClick={()=>setTempo(p.num)}>
                        <p style={{margin:'10px'}}>{p.minutos}</p>
                        <p>{p.texto}</p>
                    </PontoCel>
                )}
            </HolderPontosPcDireita>
            </Direita>
        </Tudo>
    )
}
const Holder=styled.div`
justify-content:center;
align-items:center;
height:500px;
width:500px;
max-width:100%;
`
const Direita=styled.div`
flex-direction:column;
width:calc(100% - 650px);
height:100%;
@media(max-width:850px){
position:fixed;bottom:10px;
width:650px;
justify-content:space-between;
height:70px;
flex-direction:row;
}
max-width:100%;
@media(min-width:850px){
padding:20px 0 0 0px;
width:350px
}
`
const Esquerda=styled.div`
max-width:100%;
flex-direction:column;
width:690px;
align-items:center;
height:100%;
@media(min-width:850px){
width:calc(100% - 350px);
}
`

const Resto=styled.div`
flex-direction:column;
width:100%;
align-items:center;
height:calc(100% - 650px);

`
const Tudo=styled.div`
width:calc(100% - 200px);
height:100%;
padding:10px;
align-items:center;
position:sticky;top:0;
@media(max-width:750px){
flex-direction:column;
}
@media(max-width:1150px){
width:100%;padding:0;
}
`

const Ponto=styled.aside`
display:flex;
cursor:pointer;
position:absolute;
left:calc(${p=>p.left}% - 10px);
width: 0;
height: 0;
border-left: 10px solid transparent;
border-right: 10px solid transparent;
border-bottom: 15px solid seagreen;
@media(max-width:490px){
display:none
}
`
const Balao=styled.div`
flex-direction:column;
padding:5px 7px 5px 7px;
border-top-right-radius: ${p=>p.esq?0:p=>p.tam<30?0:10}px;
border-top-left-radius: ${p=>!p.esq?0:p=>p.tam<30?0:10}px;
border-bottom-right-radius: 10px;
border-bottom-left-radius: 10px;
cursor:pointer;
position:absolute;
top:15px;color:white;
${p=>p.esq?'right:-10px':'left:-10px'};
width: max-content;
max-height:150px;

max-width:${p=>p.tam}px;

background:seagreen;
min-width:20px;
min-height:30px;
overflow:hidden;
p{margin:0;white-space: pre-line;}

@media(max-width:1150px){
max-height:85px;
}

`
const Barra=styled.div`
background:#34a6db;
width:calc(100% - 22px);
height:3px;margin-top:10px;
border-radius:1.5px;
`
const Pontos=styled.div`
width:calc(100% - 22px);
height:100px;
position:relative
`
const HolderPontos=styled.div`
flex-direction:column;
align-items:center;
width:${p=>p.tamanho}px;max-width:100%;
height:70px;
position:relative;
z-index:5;
@media(max-width:850px){
margin-top:7px;
}
`
const NovoPonto=styled.div`
margin-left:20px;
width:100%;max-width:100%;
button{
cursor:pointer;
width:100px;
height:50px;
border-radius:10px;border:0;
margin-right:20px;
}
textarea{
padding:5px;box-sizing:border-box;
border-radius:10px;border:0;
width:250px;max-width:calc(100% - 160px);
height:50px;margin-right:20px;
resize: none;    
}

@media(max-width:850px){
flex-direction:row;
textarea{margin:0 20px 0px 0;}
width:100%;
margin:0 0 0 0;
justify-content:flex-end;
}
`
const PontoFlutuante=styled.aside`
display:flex;
cursor:pointer;
position:absolute;
left:calc(${p=>p.left}% - 10px);
top:-10px;
width: 20px;
height: 20px;
border-radius:5px;
background:seagreen;
`
const HolderPontosCel=styled.aside`
flex-direction:column;display:flex;
width:100%;
height:calc(100% - 200px - 56vw);
overflow:auto;
padding-left:10px;
box-sizing:border-box;
@media(min-width:490px){
display:none
}
`
const HolderPontosPc=styled.aside`
flex-direction:column;display:flex;
width:100%;margin-top:40px;
height:calc(100% - 400px);
max-width:540px;
overflow:auto;
padding-left:10px;
box-sizing:border-box;
@media(max-width:490px){
display:none
}
@media(min-width:850px){
display:none
}
`
const HolderPontosPcDireita=styled.aside`
flex-direction:column;display:flex;
width:100%;margin-top:40px;
height:calc(100% - 100px);
max-width:540px;
overflow:auto;
padding-left:10px;
box-sizing:border-box;
@media(max-width:850px){
display:none
}
`
const PontoCel=styled.div`
background:seagreen;
height:40px;
width:98%;
border-radius:10px;
align-items:center;
margin-bottom:10px;color:white;
`
/*const BalaoFlutuante=styled.div`
border-radius:50%;
cursor:pointer;
position:absolute;
top:7.8px;left:-10px;
background:seagreen;
width:20px;
height:20px;

`
const PontoFlutuante=styled.aside`
display:flex;
cursor:pointer;
position:absolute;
left:calc(${p=>p.left}% - 10px);
width: 0;
height: 0;
border-left: 10px solid transparent;
border-right: 10px solid transparent;
border-bottom: 15px solid seagreen;
@media(min-width:850px){
display:none
}
`*/